// extracted by mini-css-extract-plugin
export var details = "_gc-0";
export var inspectorPopover = "_gc-1";